<template>
  <div class="container">
    <div class="presonal-title">
      <span>{{ $t('lang.external.personal.content.seven.修改密码') }}</span>
    </div>
    <el-form
      :model="ruleForm"
      status-icon
      :rules="rules"
      ref="ruleForm"
      label-position="left"
      class="demo-ruleForm"
    >
      <el-form-item
        :label="$t('lang.external.personal.content.seven.旧密码')"
        prop="oldpassword"
      >
        <el-input
          clearable
          type="password"
          v-model="ruleForm.oldpassword"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="$t('lang.external.personal.content.seven.设置密码')"
        prop="pass"
      >
        <el-input
          clearable
          type="password"
          v-model="ruleForm.pass"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="$t('lang.external.personal.content.seven.再次输入密码')"
        prop="checkPass"
      >
        <el-input
          clearable
          type="password"
          v-model="ruleForm.checkPass"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <div class="submit">
        <div class="per-button btn-active" @click="submitForm('ruleForm')">
          {{ $t('lang.external.personal.content.seven.保存') }}
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { modifyPassword } from '@/api/personalCenter/index'
export default {
  name: 'accountSecurity',
  components: {},
  props: [],
  data() {
    var validatePass = (rule, value, callback) => {
      var that = this
      if (value === '') {
        callback(
          new Error(this.$t('lang.external.personal.content.seven.请输入密码'))
        )
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(
          new Error(
            that.$t('lang.external.personal.content.seven.请再次输入密码')
          )
        )
      } else if (value !== this.ruleForm.pass) {
        callback(
          new Error(
            that.$t('lang.external.personal.content.seven.两次输入密码不一致!')
          )
        )
      } else {
        callback()
      }
    }
    return {
      ruleForm: {
        pass: '',
        checkPass: '',
        oldpassword: '',
      },
      rules: {
        pass: [
          {
            required: true,
            message: this.$t('lang.external.personal.content.seven.请输入密码'),
            trigger: 'blur',
          },
          { validator: validatePass, trigger: 'blur' },
        ],
        checkPass: [
          {
            required: true,
            message: this.$t(
              'lang.external.personal.content.seven.请再次输入密码'
            ),
            trigger: 'blur',
          },
          { validator: validatePass2, trigger: 'blur' },
        ],
        oldpassword: [
          {
            required: true,
            message: this.$t(
              'lang.external.personal.content.seven.请输入旧密码'
            ),
            trigger: 'blur',
          },
        ],
      },
    }
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          modifyPassword({
            userPassword: this.ruleForm.oldpassword,
            newPassword: this.ruleForm.pass,
          }).then((res) => {
            this.$notify({
              type: 'success',
              message: res.msg,
              duration: 1500,
              title: 'SUCCESS',
            })
            this.resetForm('ruleForm')
          })
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  .el-form {
    width: 40%;
    padding: 20px 30px;
    .submit {
      display: flex;
      align-items: center;
    }
  }
}
</style>